























































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import picUpload from 'vue-image-crop-upload';
import { regular, formatData } from '@/constants/commonContent';
import { Base } from '@/base';
import StripeComponent from '@/components/StripeComponent.vue';

const PRICE_VALIDATION = /^(?!0,?\d)([0-9][0-9]{0,})(\.[0-9]{1,18})?$/;

@Component({
  name: 'TheSidebarFormComponent',
  components: {
    picUpload,
    StripeComponent
  }
})
export default class TheSidebarFormComponent extends Base {
  @Prop({ default: () => ({ elements: () => ([]) }) }) formData: any;

  forPicElement: any = null;
  picUpload = {
    show: false,
    fileName: '',
    params: {
      token: '123456798',
      name: 'avatar'
    },
    headers: {
      smail: '*_~'
    },
    imgDataUrl: '',
    wrapperClass: 'vicp-wrap',
    size: {
      height: 200,
      weight: 410
    }
  };

  // Computed
  get formButtons () {
    return Array.from(this.formData.elements).filter((element: any) => {
      if (['submit', 'reset'].includes(element.data.type)) {
        return element;
      }
    });
  }

  // Methods
  toggleShow (element) {
    this.picUpload.show = !this.picUpload.show;
    this.forPicElement = element;
  }

  cropSuccess (imgDataUrl, field) {
    this.picUpload.imgDataUrl = imgDataUrl;
    this.updateModel(this.picUpload.fileName, {data: {name: 'profile-picture'}});
  }

  cropUploadSuccess (jsonData, field) {
  };

  cropUploadFail (status, field) {
  };

  srcFileSet (fileName) {
    this.picUpload.fileName = fileName;
  }

  validValue (element, value) {
    if (element.type === 'payment') return;
    let validate = true;
    this.updateHasError(false, element);
    if (value !== null || value !== undefined) this.updateModel(value, element);
    if (element.type === 'input' || element.data.name === 'textarea-input') {
      if (!this.formValidation(element)) {
        validate = false;
      }
    }
    if (element.data.type === 'select') {
      if (!this.formValidation(element)) {
        validate = false;
      }
    }
    // Count Eth in USD
    if (element.data.name === 'price-order') {
      const textEl = this.formData.elements.find(el => el.data.name === 'approximate');
      this.updateModel(textEl.data.approximateValue(element.data.model), textEl);
    }
    if (element.data.name === 'amount-input') {
      const textInsufficient = this.formData.elements.find(el => el.data.name === 'insufficient');
      const priceOrder = this.formData.elements.find(el => el.data.name === 'price-input');
      if (priceOrder) {
        const buySell = this.formData.elements.find(el => el.data.name === 'buy-input');
        const amountCost = +element.data.model * +priceOrder.data.model;
        if (buySell.data.model === 'Buy' && textInsufficient && +amountCost > +this.getBalance) {
          this.updateModel(textInsufficient.data.getMessage(), textInsufficient);
        } else {
          this.updateModel('', textInsufficient);
        }
      }
    }
  }

  submit () {
    let result: any = [];
    let validate = true;
    this.formData.elements.forEach(element => {
      if (element.type !== 'payment') {
        this.updateHasError(false, element);
      } else {
        validate = !element.hasError;
      }
      if (element.type === 'input') {
        if (!this.formValidation(element)) {
          validate = false;
        }
      }
      this.$forceUpdate();
    });
    if (validate) {
      this.formData.elements.forEach((element: any) => {
        if (element.data.name === 'profile-picture') {
          result.push(this.picUpload.fileName);
          result.push(this.picUpload.imgDataUrl);
        } else {
          result.push(element.data.model);
        }
        if (!['submit', 'reset'].includes(element.data.type)) this.updateModel('', element)
      });
      this.formData.submit(result);
      if (!this.formData.preventClose) this.openClose();
    }
  }

  reset () {
    let result: any = [];
    let validate = true;
    this.formData.elements.forEach(element => {
      if (element.type !== 'payment') this.updateHasError(false, element);
      if (element.type === 'input') {
        if (!this.formValidation(element)) {
          validate = false;
        }
      }
      this.$forceUpdate();
    });
    if (validate) {
      this.formData.elements.forEach((element: any) => {
        if (element.data.name === 'profile-picture') {
          result.push(this.picUpload.fileName);
          result.push(this.picUpload.imgDataUrl);
        } else {
          result.push(element.data.model);
        }
        this.updateModel('', element)
      });
      this.formData.reset();
      this.openClose();
    }
  }

  formValidation (el) {
    let isValidated = true;
    if (el.data.required) {
      if (
        (!el.data.model && typeof el.data.model !== 'boolean') ||
        (el.data.type === 'email' && !this.isEmail(el.data.model)) ||
        (el.data.name === 'address' &&
          (el.data.model.slice(0, 2) !== '0x' || el.data.model.length !== 42))
      ) {
        isValidated = false;
      }
      // Start validation for order amount
      if (el.data.name === 'mode-select') {
        const amount = this.formData.elements.find(
          element => element.data.label === 'Amount of shares'
        );
        if (el.data.model === 2) {
          // amount.data.max = amount.data.defaultMax || amount.data.max;
          this.updateData(amount.data.defaultMax || amount.data.max, 'max', amount);
          if (amount.data.model > amount.data.max) this.updateHasError(true, amount);
        } else {
          // amount.data.max = null;
          this.updateData(null, 'max', amount);
          this.updateHasError(false, amount);
        }
      }
      if (el.data.id === 'order-amount') {
        const mode = this.formData.elements.find(element => element.data.name === 'mode-select');
        if (mode && mode.data.model !== 2) {
          if (!el.data.defaultMax) el.data.defaultMax = el.data.max;
          el.data.max = null;
        } else if (el.data.defaultMax) {
          el.data.max = el.data.defaultMax;
        }
      }
      // End validation for order amount
      if (typeof el.data.min === 'number') {
        if (
          (el.data.type === 'number' && el.data.min > el.data.model) ||
          (el.data.type !== 'number' && el.data.min > el.data.model.length)
        )
          isValidated = false;
      }
      if (typeof el.data.max === 'number') {
        if (
          (el.data.type === 'number' && el.data.max < el.data.model) ||
          (el.data.type !== 'number' && el.data.max < el.data.model.length)
        )
          isValidated = false;
      }
      if (el.data.type === 'date') {
        if (!el.data.model) isValidated = false;
        let now = Vue.moment();
        let nextDate = Vue.moment(el.data.model, formatData.systemDate).add(1, 'day');
        if (!nextDate._isValid || now.isAfter(nextDate)) isValidated = false;
      }
      if (el.data.address) {
        if (!el.data.address.validateAddr(el.data.model)) isValidated = false;
      }
      if (el.data.type === 'datetime') {
        if (!el.data.model) {
          isValidated = false;
        }
      }
      if (el.data.name === 'price-order') {
        if (!el.data.model.match(PRICE_VALIDATION)) {
          isValidated = false;
        }
      }
      if (el.data.pattern) {
        if (!el.data.model.match(el.data.pattern)) {
          isValidated = false;
        }
      }
      if (el.data.name === 'receiver-select') {
        if (el.data.model === null) {
          isValidated = false;
        }
      }
    }
    if (isValidated) return true;

    this.updateHasError(true, el);
    return false;
  }

  isEmail (email) {
    return regular.validate.email.test(email);
  }

  isHaveError (el) {
    return el.hasError;
  }

  onFileChange(e, element) {
    if (e) this.updateModel(e.target.files[0], element);
  }
  
  updateModel(value, element) {
    this.$store.commit('setSideBarFormModel', {model: value, name: element.data.name});
  }

  updateHasError(value, element) {
    this.$store.commit('setSideBarFormHasError', {value, name: element.data.name});
  }

  updateData(value, prop, element) {
    this.$store.commit('setSideBarFormDataValue', {value: value, prop, name: element.data.name});
  }
};
